<template>
  <div class="city-code">
    <cityCode />
  </div>
</template>

<script>
import cityCode from '@/components/citycode/index'
export default {
  components: { cityCode },
}
</script>

<style scoped>

</style>